// extracted by mini-css-extract-plugin
export default {"spinner":"PageSpinner--spinner--X6tQ3","fixed":"PageSpinner--fixed--Gtoge","content":"PageSpinner--content--ll2Km"};